const pt = {
  common: {
    actions: {
      previous: "Anterior",
      next: "Pr\u00f3ximo",
      showPrevious: "Mostrar itens anteriores",
      showNext: "Mostrar pr\u00f3ximos itens",
      openMenu: "Abrir menu de navega\u00e7\u00e3o",
      changeLanguage: "Mudar idioma",
    },
    labels: {
      language: "Idioma",
    },
    cta: {
      contact: "Contacte-nos",
      learnMore: "Saber mais",
      exploreApproach: "Explorar a nossa abordagem",
      submit: "Enviar",
    },
    forms: {
      firstName: "Primeiro nome",
      lastName: "Apelido",
      email: "Email",
      phoneNumber: "N\u00famero de telefone",
      message: "Mensagem",
      emailPlaceholder: "voce@empresa.com",
      phonePlaceholder: "+244 000 000 000",
      intlPhonePlaceholder: "+1 (555) 000-0000",
      messagePlaceholder: "Deixe-nos uma mensagem...",
      validation: {
        firstNameRequired: "O primeiro nome \u00e9 obrigat\u00f3rio.",
        lastNameRequired: "O apelido \u00e9 obrigat\u00f3rio.",
        emailRequired: "O email \u00e9 obrigat\u00f3rio.",
        invalidEmail: "Introduza um endere\u00e7o de email v\u00e1lido.",
        phoneRequired: "O n\u00famero de telefone \u00e9 obrigat\u00f3rio.",
        invalidPhone: "Introduza um n\u00famero de telefone v\u00e1lido.",
        messageRequired: "A mensagem \u00e9 obrigat\u00f3ria.",
      },
    },
    feedback: {
      sending: "A enviar...",
      messageSent: "A sua mensagem foi enviada com sucesso.",
      somethingWrong: "Algo correu mal. Tente novamente.",
      serverError: "Erro do servidor. Tente novamente mais tarde.",
    },
    siteCta: {
      title: "O seu parceiro estrat\u00e9gico para transformar Angola",
      text: "Trabalhamos com governos, investidores e institui\u00e7\u00f5es para desbloquear oportunidades estrat\u00e9gicas e apoiar a transforma\u00e7\u00e3o econ\u00f3mica sustent\u00e1vel em Angola.",
    },
    company: {
      shortDescription: "Trabalhamos com governos, investidores e institui\u00e7\u00f5es para desbloquear oportunidades estrat\u00e9gicas e apoiar a transforma\u00e7\u00e3o econ\u00f3mica sustent\u00e1vel em Angola.",
      locationLuanda: "Rua Frederico Welwitschia Torre Maculusso, 5.\u00ba Andar Luanda, Angola",
      locationCapeTown: "The Estuaries, Building 12 Century City Cape Town, 7441",
    },
    footer: {
      quickLinks: "Links r\u00e1pidos",
      servicesTitle: "Os nossos servi\u00e7os",
      phoneLabel: "Telefone:",
      copyright: "\u00a9 2027 Provest Capital Management. Todos os direitos reservados.",
      links: {
        home: "In\u00edcio",
        about: "Sobre n\u00f3s",
        services: "Servi\u00e7os",
        newsroom: "Not\u00edcias",
        contact: "Contacte-nos",
      },
      services: [
        "Obras p\u00fablicas e civis",
        "Projetos residenciais",
        "Infraestruturas industriais",
        "Reabilita\u00e7\u00e3o e renova\u00e7\u00e3o",
        "Gest\u00e3o e supervis\u00e3o de projetos",
      ],
      legal: {
        privacy: "Pol\u00edtica de Privacidade",
        terms: "Termos e Condi\u00e7\u00f5es",
      },
    },
  },
  header: {
    nav: {
      home: "In\u00edcio",
      about: "Sobre n\u00f3s",
      ourPosition: "A nossa posi\u00e7\u00e3o",
      esg: "ESG",
      contact: "Contacte-nos",
      solutions: "Solu\u00e7\u00f5es",
      privateSector: "Setor privado",
      publicSector: "Setor p\u00fablico",
    },
  },
  pages: {
    home: {
      hero: {
        title: "Estrat\u00e9gia e resolu\u00e7\u00e3o de problemas para projetos de alto impacto",
      },
      moment: {
        title: "Angola num momento decisivo",
        subtitle: "O potencial de diversifica\u00e7\u00e3o \u00e9 enorme, mas a complexidade exige mais do que capital: exige m\u00e9todo e execu\u00e7\u00e3o.",
        cards: [
          {
            title: "Diversifica\u00e7\u00e3o econ\u00f3mica",
            text: "Transi\u00e7\u00e3o urgente de uma economia dependente do petr\u00f3leo para setores produtivos e diversificados. Constru\u00e7\u00e3o de bases econ\u00f3micas sustent\u00e1veis.",
          },
          {
            title: "Capital inteligente",
            text: "Estrutura\u00e7\u00e3o financeira sofisticada para viabilizar projetos de longo prazo. Investimentos estrat\u00e9gicos que criam valor sustent\u00e1vel.",
          },
          {
            title: "Execu\u00e7\u00e3o disciplinada",
            text: "Capacidade para navegar o contexto operacional e garantir uma implementa\u00e7\u00e3o eficaz. Fortes quadros de governa\u00e7\u00e3o e responsabiliza\u00e7\u00e3o.",
          },
        ],
      },
      positioning: {
        title: "A nossa posi\u00e7\u00e3o",
        subtitle: "Estrat\u00e9gia + resolu\u00e7\u00e3o de problemas: pensamento estrat\u00e9gico s\u00f3lido combinado com verdadeira capacidade de execu\u00e7\u00e3o",
        strategyTitle: "Estrat\u00e9gia",
        strategyText: "An\u00e1lise estrat\u00e9gica aprofundada do contexto econ\u00f3mico, institucional e setorial para:",
        strategyPoints: [
          "Clarificar as prioridades cr\u00edticas de cada projeto",
          "Identificar oportunidades reais de cria\u00e7\u00e3o de valor",
          "Desenhar solu\u00e7\u00f5es estruturadas que apoiem decis\u00f5es de investimento informadas",
        ],
        problemTitle: "Resolu\u00e7\u00e3o de problemas",
        problemText: "Apoio pr\u00e1tico \u00e0 implementa\u00e7\u00e3o, navegando a complexidade real dos projetos:",
        problemPoints: [
          "Ultrapassar obst\u00e1culos institucionais e operacionais",
          "Coordena\u00e7\u00e3o eficaz entre stakeholders",
          "Garantir execu\u00e7\u00e3o disciplinada desde a estrutura\u00e7\u00e3o at\u00e9 \u00e0 opera\u00e7\u00e3o",
        ],
      },
      who: {
        title: "Quem somos",
        subtitle: "Uma empresa angolana especializada em estrutura\u00e7\u00e3o de projetos, gest\u00e3o estrat\u00e9gica e mobiliza\u00e7\u00e3o de capital.",
        missionTitle: "A nossa miss\u00e3o",
        missionText: "Apoiar empresas e institui\u00e7\u00f5es na cria\u00e7\u00e3o de valor sustent\u00e1vel e no acesso a capital estrat\u00e9gico, atrav\u00e9s de uma abordagem assente em transpar\u00eancia, profissionalismo e responsabilidade.",
        visionTitle: "A nossa vis\u00e3o",
        visionText: "Tornar-nos um parceiro de refer\u00eancia na mobiliza\u00e7\u00e3o de capital para projetos estruturados que impulsionem a economia real de Angola, atrav\u00e9s de um alinhamento duradouro entre estrat\u00e9gia, capital e execu\u00e7\u00e3o.",
      },
      operating: {
        title: "A nossa forma de atuar",
        subtitle: "Atuamos onde convergem a estrat\u00e9gia, o capital e a execu\u00e7\u00e3o.",
        cards: [
          {
            id: "01",
            title: "Estrat\u00e9gia e modela\u00e7\u00e3o",
            points: [
              "Defini\u00e7\u00e3o de orienta\u00e7\u00e3o estrat\u00e9gica e viabilidade econ\u00f3mica",
              "Gest\u00e3o rigorosa do risco para apoiar decis\u00f5es de investimento informadas",
            ],
          },
          {
            id: "02",
            title: "Estrutura\u00e7\u00e3o e capital",
            points: [
              "Estrutura\u00e7\u00e3o financeira e mobiliza\u00e7\u00e3o de capital com bancos e fundos",
              "Modela\u00e7\u00e3o financeira alinhada com a escala e o perfil de risco do projeto",
            ],
          },
          {
            id: "03",
            title: "Parcerias t\u00e9cnicas",
            points: [
              "Sele\u00e7\u00e3o e integra\u00e7\u00e3o de parceiros t\u00e9cnicos e operacionais de refer\u00eancia",
              "Transfer\u00eancia eficaz de know-how e melhores pr\u00e1ticas",
            ],
          },
          {
            id: "04",
            title: "Execu\u00e7\u00e3o e navega\u00e7\u00e3o",
            points: [
              "Monitoriza\u00e7\u00e3o cont\u00ednua e coordena\u00e7\u00e3o institucional",
              "Alinhamento total entre estrat\u00e9gia, capital e execu\u00e7\u00e3o",
            ],
          },
        ],
      },
      solutions: {
        title: "As nossas solu\u00e7\u00f5es",
        subtitle: "Desenvolvemos estrat\u00e9gias \u00e0 medida em diferentes setores para impulsionar crescimento sustent\u00e1vel e vantagem competitiva.",
        items: [
          {
            title: "Setor privado",
            desc: "Solu\u00e7\u00f5es estrat\u00e9gicas e orientadas para a execu\u00e7\u00e3o que ajudam as empresas a expandir, otimizar o desempenho e alcan\u00e7ar crescimento sustent\u00e1vel em mercados competitivos.",
          },
          {
            title: "Setor p\u00fablico",
            desc: "Apoio de consultoria e implementa\u00e7\u00e3o para governos e institui\u00e7\u00f5es desenvolverem projetos de impacto, refor\u00e7arem infraestruturas e promoverem progresso econ\u00f3mico de longo prazo.",
          },
        ],
      },
      esg: {
        title: "ESG como alavanca de execu\u00e7\u00e3o",
        subtitle: "Integramos princ\u00edpios ambientais, sociais e de governa\u00e7\u00e3o na execu\u00e7\u00e3o dos projetos para garantir sustentabilidade de longo prazo e desenvolvimento respons\u00e1vel.",
        items: [
          {
            title: "Responsabilidade ambiental",
            desc: "Compromisso com pr\u00e1ticas ambientalmente respons\u00e1veis.",
          },
          {
            title: "Impacto social",
            desc: "Projetos concebidos para gerar benef\u00edcios sociais significativos.",
          },
          {
            title: "Transpar\u00eancia de governa\u00e7\u00e3o",
            desc: "Fortes padr\u00f5es de governa\u00e7\u00e3o que asseguram responsabiliza\u00e7\u00e3o.",
          },
          {
            title: "Quadros de investimento sustent\u00e1vel",
            desc: "Estrat\u00e9gias de investimento alinhadas com princ\u00edpios de sustentabilidade.",
          },
        ],
      },
    },
    about: {
      hero: {
        title: "Constru\u00eddos para o momento decisivo de Angola",
        text: "Uma empresa nascida da convic\u00e7\u00e3o de que o potencial de Angola exige mais do que ambi\u00e7\u00e3o. Exige estrat\u00e9gia, disciplina e execu\u00e7\u00e3o ancoradas em profundo conhecimento local.",
      },
      stats: [
        { value: "10+", label: "Anos de experi\u00eancia" },
        { value: "40+", label: "Projetos executados" },
        { value: "$2B+", label: "Capital estruturado" },
        { value: "12", label: "Setores abrangidos" },
        { value: "5", label: "Pa\u00edses de opera\u00e7\u00e3o" },
      ],
      story: {
        badgeLabel: "PARTE DE",
        badgeTitle: "PROVEST HOLDING",
        badgeText: "Com sede na \u00c1frica do Sul",
        title: "Constru\u00eddos na interse\u00e7\u00e3o entre estrat\u00e9gia, capital e execu\u00e7\u00e3o",
        paragraphOne: "A PRO-VEST Capital Management \u00e9 uma empresa angolana especializada em estrutura\u00e7\u00e3o de projetos, gest\u00e3o estrat\u00e9gica e mobiliza\u00e7\u00e3o de capital, combinando a disciplina das finan\u00e7as internacionais com uma profunda intelig\u00eancia de mercado local.",
        paragraphTwo: "Somos parte da PROVEST Holding, com sede na \u00c1frica do Sul, o que refor\u00e7a a nossa capacidade de executar projetos da economia real em Angola, trazendo estrutura corporativa internacional e capacidades globais para a execu\u00e7\u00e3o local.",
        quote: "N\u00e3o nos limitamos a aconselhar. Estruturamos, capitalizamos e executamos mantendo total responsabilidade ao longo de todo o ciclo de vida do projeto.",
      },
      pillars: {
        title: "Tr\u00eas pilares da nossa abordagem",
        text: "Cada projeto \u00e9 constru\u00eddo na interse\u00e7\u00e3o entre intelig\u00eancia de capital, rigor operacional e integridade de governa\u00e7\u00e3o.",
        items: [
          {
            id: "01",
            title: "Intelig\u00eancia estrat\u00e9gica de capital",
            description: "Identificamos onde o capital inteligente cria efeitos multiplicadores, e n\u00e3o apenas retorno. Estrutura\u00e7\u00e3o financeira alinhada com as realidades macroecon\u00f3micas de Angola e os objetivos de desenvolvimento de longo prazo.",
            tags: ["Estrutura\u00e7\u00e3o de capital", "Modela\u00e7\u00e3o de risco", "Estrat\u00e9gia de investimento"],
          },
          {
            id: "02",
            title: "Execu\u00e7\u00e3o operacional",
            description: "Estrat\u00e9gia sem execu\u00e7\u00e3o \u00e9 fic\u00e7\u00e3o. Mantemo-nos presentes desde a conce\u00e7\u00e3o at\u00e9 \u00e0 conclus\u00e3o, navegando o ambiente operacional angolano com disciplina e responsabiliza\u00e7\u00e3o.",
            tags: ["Gest\u00e3o de projeto", "Apoio PMO", "Monitoriza\u00e7\u00e3o de KPI"],
          },
          {
            id: "03",
            title: "Governa\u00e7\u00e3o e transpar\u00eancia",
            description: "A confian\u00e7a \u00e9 o nosso modelo operacional. Cada estrutura que criamos incorpora transpar\u00eancia, responsabiliza\u00e7\u00e3o e princ\u00edpios de investimento respons\u00e1vel, criando valor sustent\u00e1vel para todos os stakeholders.",
            tags: ["Integra\u00e7\u00e3o ESG", "Conformidade", "Relat\u00f3rios"],
          },
        ],
      },
      who: {
        title: "Quem somos",
        subtitle: "Uma empresa angolana especializada em estrutura\u00e7\u00e3o de projetos, gest\u00e3o estrat\u00e9gica e mobiliza\u00e7\u00e3o de capital.",
        missionTitle: "A nossa miss\u00e3o",
        missionText: "Apoiar empresas e institui\u00e7\u00f5es na cria\u00e7\u00e3o de valor sustent\u00e1vel e no acesso a capital estrat\u00e9gico, atrav\u00e9s de uma abordagem assente em transpar\u00eancia, profissionalismo e responsabilidade.",
        visionTitle: "A nossa vis\u00e3o",
        visionText: "Tornar-nos um parceiro de refer\u00eancia na mobiliza\u00e7\u00e3o de capital para projetos estruturados que impulsionem a economia real de Angola, atrav\u00e9s de um alinhamento duradouro entre estrat\u00e9gia, capital e execu\u00e7\u00e3o.",
      },
      values: {
        title: "Valores que orientam cada decis\u00e3o",
        text: "Assentes em princ\u00edpios fortes, os nossos valores moldam a nossa cultura e impulsionam a excel\u00eancia consistente, ajudando-nos a entregar solu\u00e7\u00f5es fi\u00e1veis, impactantes e orientadas para o futuro.",
        items: [
          {
            title: "Responsabiliza\u00e7\u00e3o sem compromisso",
            description: "Somos medidos pelos resultados, n\u00e3o pelo esfor\u00e7o. Cada projeto que lideramos tem uma estrutura clara de responsabiliza\u00e7\u00e3o e impomo-la a n\u00f3s mesmos antes de o exigir aos outros.",
            featured: true,
          },
          {
            title: "Integridade como modelo de neg\u00f3cio",
            description: "Transpar\u00eancia n\u00e3o \u00e9 apenas conformidade. \u00c9 vantagem competitiva. A nossa reputa\u00e7\u00e3o \u00e9 o nosso ativo mais duradouro.",
          },
          {
            title: "Local primeiro, padr\u00e3o global",
            description: "Operamos com a proximidade de um parceiro local e o rigor de uma institui\u00e7\u00e3o global.",
          },
          {
            title: "Pensamento de longo prazo",
            description: "Otimizamos a cria\u00e7\u00e3o de valor a n\u00edvel de d\u00e9cadas, n\u00e3o a n\u00edvel trimestral. A transforma\u00e7\u00e3o de Angola \u00e9 geracional.",
          },
          {
            title: "Inova\u00e7\u00e3o disciplinada",
            description: "Levamos pensamento novo a problemas antigos, sempre ancorados em evid\u00eancia, viabilidade e nas realidades da execu\u00e7\u00e3o no terreno.",
          },
        ],
      },
      document: {
        title: "Certificado provisório de registo da ANPG",
        text: "Consulte o certificado provisório de registo da PVMT-PROVEST Capital Management para o setor de petróleo e gás em Angola, emitido pela Agência Nacional de Petróleo, Gás e Biocombustíveis.",
        fallback: "Este navegador n\u00e3o consegue apresentar o PDF diretamente.",
        open: "Abrir PDF",
      },
    },
    ourPosition: {
      hero: {
        title: "Pensamento estrat\u00e9gico s\u00f3lido combinado com verdadeira capacidade de execu\u00e7\u00e3o",
        text: "Estamos na interse\u00e7\u00e3o entre estrat\u00e9gia e execu\u00e7\u00e3o, n\u00e3o como consultores que saem depois da apresenta\u00e7\u00e3o, mas como parceiros que permanecem na complexidade e entregam resultados mensur\u00e1veis.",
      },
      positioning: {
        title: "A nossa posi\u00e7\u00e3o",
        text: "Estrat\u00e9gia + resolu\u00e7\u00e3o de problemas: pensamento estrat\u00e9gico s\u00f3lido combinado com verdadeira capacidade de execu\u00e7\u00e3o",
        keyCapabilities: "Capacidades-chave",
        sections: [
          {
            eyebrow: "Estrat\u00e9gia",
            title: "Planeamento estrat\u00e9gico aprofundado para resultados mais inteligentes.",
            description: "Analisamos din\u00e2micas de mercado, contexto institucional e objetivos do projeto para construir uma base s\u00f3lida para o sucesso.",
            capabilities: [
              "Identificar prioridades-chave e oportunidades de crescimento",
              "Alinhar a estrat\u00e9gia com objetivos financeiros e de neg\u00f3cio",
              "Desenvolver planos de execu\u00e7\u00e3o estruturados e sustentados por dados",
              "Permitir decis\u00f5es informadas e confiantes",
            ],
          },
          {
            eyebrow: "Resolu\u00e7\u00e3o de problemas",
            title: "Solu\u00e7\u00f5es pr\u00e1ticas que transformam desafios em progresso.",
            description: "Prestamos apoio pr\u00e1tico para navegar complexidades e assegurar uma execu\u00e7\u00e3o fluida do planeamento at\u00e9 \u00e0 entrega.",
            capabilities: [
              "Superar desafios operacionais e estruturais",
              "Alinhar stakeholders e simplificar processos",
              "Impulsionar uma execu\u00e7\u00e3o eficiente com responsabiliza\u00e7\u00e3o clara",
              "Assegurar consist\u00eancia da estrat\u00e9gia \u00e0 implementa\u00e7\u00e3o",
            ],
          },
        ],
      },
      convergence: {
        title: "Onde convergem estrat\u00e9gia, capital e execu\u00e7\u00e3o",
        text: "Atuamos na converg\u00eancia de tr\u00eas for\u00e7as: clareza estrat\u00e9gica, capital inteligente e execu\u00e7\u00e3o disciplinada para gerar resultados na economia real.",
        techStrip: "Tecnologia e intelig\u00eancia de dados: an\u00e1lise de risco mais inteligente com insights orientados por IA.",
        cards: [
          {
            id: "01",
            title: "Estrat\u00e9gia e modela\u00e7\u00e3o",
            description: "Liga estrat\u00e9gia, an\u00e1lise e tomada de decis\u00e3o. An\u00e1lise rigorosa de risco para apoiar a melhor escolha de investimento e a cria\u00e7\u00e3o de valor de longo prazo para todos os stakeholders.",
          },
          {
            id: "02",
            title: "Estrutura\u00e7\u00e3o e capital",
            description: "Estrutura\u00e7\u00e3o para obter acesso a capital com parceiros e investidores. Modela\u00e7\u00e3o financeira alinhada com a escala do projeto, perfil de risco e sustentabilidade de longo prazo.",
          },
          {
            id: "03",
            title: "Parcerias t\u00e9cnicas",
            description: "Selecionar e integrar parceiros t\u00e9cnicos de refer\u00eancia para aceder a capital estrat\u00e9gico, atrav\u00e9s de uma abordagem ancorada em melhores pr\u00e1ticas internacionais e conhecimento local.",
          },
          {
            id: "04",
            title: "Execu\u00e7\u00e3o e navega\u00e7\u00e3o",
            description: "Monitoriza\u00e7\u00e3o cont\u00ednua e coordena\u00e7\u00e3o institucional. Alinhamento total entre estrat\u00e9gia, capital e execu\u00e7\u00e3o ao longo de toda a opera\u00e7\u00e3o, do primeiro desembolso \u00e0 entrega final.",
          },
        ],
      },
      differentiators: {
        title: "Os nossos diferenciadores competitivos",
        text: "Cinco raz\u00f5es pelas quais a PRO-VEST \u00e9 o parceiro estrat\u00e9gico certo para projetos complexos em Angola. Passe o cursor por cada linha para explorar.",
        items: [
          {
            id: "01",
            title: "Execution-first, always",
            description: "N\u00e3o somos uma consultora que desaparece depois da apresenta\u00e7\u00e3o. Permanecemos durante toda a complexidade, da estrutura\u00e7\u00e3o \u00e0 opera\u00e7\u00e3o, mantendo total responsabiliza\u00e7\u00e3o pelos resultados. O nosso modelo de neg\u00f3cio baseia-se na entrega, n\u00e3o no aconselhamento.",
            badge: "Vantagem central",
          },
          {
            id: "02",
            title: "Local intelligence",
            description: "Conhecimento profundo do mercado angolano que n\u00e3o pode ser replicado por empresas que operam a partir do exterior. Conhecemos as institui\u00e7\u00f5es, as din\u00e2micas e o caminho atrav\u00e9s da complexidade. O conhecimento local \u00e9 a nossa principal vantagem competitiva.",
            badge: "Mercado",
          },
          {
            id: "03",
            title: "International standards",
            description: "Apoiados pela PROVEST Holding na \u00c1frica do Sul, levamos estrutura corporativa internacional e uma rede global que elevam cada projeto a padr\u00f5es internacionais de rigor e governa\u00e7\u00e3o. Execu\u00e7\u00e3o local, padr\u00f5es globais.",
            badge: "Rede",
          },
          {
            id: "04",
            title: "ESG as an edge",
            description: "Integramos princ\u00edpios ambientais, sociais e de governa\u00e7\u00e3o no desenho dos projetos n\u00e3o como requisito de conformidade, mas como alavanca estrat\u00e9gica que desbloqueia melhor capital, melhores parceiros e resultados mais duradouros para cada stakeholder.",
            badge: "Sustentabilidade",
          },
          {
            id: "05",
            title: "Proven track record",
            description: "Mais de 2 mil milh\u00f5es de d\u00f3lares em capital estruturado, mais de 40 projetos executados e uma d\u00e9cada a construir credibilidade junto de governos, institui\u00e7\u00f5es e investidores internacionais em Angola e na regi\u00e3o. Os n\u00fameros falam por si.",
            badge: "Hist\u00f3rico",
          },
        ],
      },
      stats: [
        { value: "10+", label: "Anos a entregar na economia real de Angola" },
        { value: "40+", label: "Projetos executados nos setores privado e p\u00fablico" },
        { value: "$2B+", label: "Capital estruturado em todos os projetos" },
        { value: "5", label: "Pa\u00edses com opera\u00e7\u00e3o ativa" },
      ],
    },
    esg: {
      hero: {
        title: "ESG como alavanca de execu\u00e7\u00e3o",
        text: "Integramos princ\u00edpios ambientais, sociais e de governa\u00e7\u00e3o no desenho e implementa\u00e7\u00e3o dos projetos, garantindo sustentabilidade de longo prazo e desenvolvimento respons\u00e1vel.",
        pillarsLabel: "Pilares ESG",
        pillars: [
          { key: "E", label: "Ambiental" },
          { key: "S", label: "Social" },
          { key: "G", label: "Governa\u00e7\u00e3o" },
        ],
      },
      stats: [
        { value: "100%", label: "Projetos com enquadramento ESG" },
        { value: "3", label: "Pilares ESG integrados" },
        { value: "10+", label: "Anos de investimento respons\u00e1vel" },
        { value: "4", label: "Pa\u00edses abrangidos" },
      ],
      intro: {
        kicker: "ESG como alavanca de execu\u00e7\u00e3o",
        title: "Integramos os princípios ESG em todos os projetos e decisões.",
        caption: "Num momento em que os mercados exigem simultaneamente desempenho e responsabilidade, o ESG não é para nós uma simples exigência de reporte — é uma alavanca estratégica que orienta a forma como o capital é alocado, como os projetos são estruturados e como os resultados são entregues. Integramos os princípios ambientais, sociais e de governação desde as fases iniciais de planeamento até à execução e supervisão, garantindo que cada decisão esteja alinhada com a criação de valor a longo prazo.",
        caption1: "Ao integrar o ESG nos nossos processos centrais, reforçamos a gestão de riscos, aumentamos a transparência e construímos confiança junto das partes interessadas. Esta abordagem permite-nos promover investimentos mais resilientes, fortalecer parcerias e entregar projetos que não são apenas comercialmente sólidos, mas também socialmente responsáveis e ambientalmente sustentáveis.",
        paragraphs: [
          "O momento decisivo de Angola exige capital que seja n\u00e3o s\u00f3 inteligente, mas tamb\u00e9m respons\u00e1vel. Para n\u00f3s, ESG n\u00e3o \u00e9 uma caixa de relat\u00f3rio. \u00c9 uma alavanca estrat\u00e9gica que desbloqueia capital, fortalece parcerias e entrega resultados de projeto.",
          "Integramos princ\u00edpios ambientais, sociais e de governa\u00e7\u00e3o no desenho e implementa\u00e7\u00e3o dos projetos, garantindo sustentabilidade de longo prazo e desenvolvimento respons\u00e1vel em todos os nossos mandatos.",
        ],
        quote: "ESG como alavanca de execu\u00e7\u00e3o significa integrar princ\u00edpios ambientais, sociais e de governa\u00e7\u00e3o na execu\u00e7\u00e3o dos projetos para garantir sustentabilidade de longo prazo.",
      },
      environmental: {
        title: "Responsabilidade ambiental",
        text: "Compromisso com pr\u00e1ticas ambientalmente respons\u00e1veis em cada projeto que estruturamos e executamos em Angola e na regi\u00e3o.",
        badgeLabel: "Ambiental - E",
        badgeText: "Projetos com avalia\u00e7\u00e3o de impacto ambiental",
        items: [
          {
            title: "Avalia\u00e7\u00e3o de impacto ambiental",
            description: "Cada projeto inclui uma revis\u00e3o ambiental abrangente antes do in\u00edcio da estrutura\u00e7\u00e3o, cobrindo riscos, mitiga\u00e7\u00e3o e m\u00e9tricas de sustentabilidade de longo prazo.",
          },
          {
            title: "Integra\u00e7\u00e3o de pr\u00e1ticas respons\u00e1veis",
            description: "Alinhamos os projetos com pr\u00e1ticas ambientalmente respons\u00e1veis para que a entrega contribua positivamente para o ambiente natural de Angola e para os padr\u00f5es internacionais.",
          },
          {
            title: "Capital alinhado com o clima",
            description: "O capital \u00e9 direcionado para projetos que apoiam resili\u00eancia, diversifica\u00e7\u00e3o e metas mensur\u00e1veis de transi\u00e7\u00e3o ambiental.",
          },
        ],
      },
      social: {
        title: "Impacto social",
        text: "Projetos desenhados para gerar benef\u00edcios sociais significativos atrav\u00e9s de emprego, resili\u00eancia e maior participa\u00e7\u00e3o local.",
        panelLabel: "Impacto social - S",
        panelTitle: "Comunidade em primeiro lugar",
        panelText: "Cada projeto avaliado pelo seu retorno social",
        items: [
          {
            title: "Cria\u00e7\u00e3o de emprego",
            description: "Cada projeto que estruturamos \u00e9 avaliado quanto \u00e0 cria\u00e7\u00e3o direta e indireta de emprego, priorizando fun\u00e7\u00f5es significativas e sustent\u00e1veis para trabalhadores angolanos.",
          },
          {
            title: "Resili\u00eancia comunit\u00e1ria",
            description: "Apoiamos projetos que refor\u00e7am a capacidade local, melhoram o acesso a servi\u00e7os e reduzem a vulnerabilidade atrav\u00e9s de resultados pr\u00e1ticos para as comunidades.",
          },
          {
            title: "Melhoria dos meios de subsist\u00eancia",
            description: "Para al\u00e9m das infraestruturas, procuramos benef\u00edcio social mensur\u00e1vel atrav\u00e9s do acesso a oportunidades econ\u00f3micas, servi\u00e7os essenciais e inclus\u00e3o de longo prazo.",
          },
        ],
      },
      governance: {
        title: "Transpar\u00eancia de governa\u00e7\u00e3o",
        text: "Fortes padr\u00f5es de governa\u00e7\u00e3o asseguram responsabiliza\u00e7\u00e3o, relat\u00f3rio transparente e comportamento institucional respons\u00e1vel.",
        items: [
          {
            title: "Padr\u00f5es de transpar\u00eancia",
            description: "Fortes padr\u00f5es de governa\u00e7\u00e3o asseguram responsabiliza\u00e7\u00e3o em todos os mandatos, com relat\u00f3rio e divulga\u00e7\u00e3o incorporados na estrutura do projeto desde o in\u00edcio.",
          },
          {
            title: "Quadros de conformidade",
            description: "Quadros abrangentes de conformidade alinham-se com padr\u00f5es internacionais de governa\u00e7\u00e3o para que cada projeto cumpra os requisitos de investidores e institui\u00e7\u00f5es financeiras de desenvolvimento.",
          },
          {
            title: "Estruturas de responsabiliza\u00e7\u00e3o",
            description: "Estruturas claras de responsabiliza\u00e7\u00e3o protegem os interesses de investidores, governos, comunidades e operadores ao longo de todo o ciclo de execu\u00e7\u00e3o.",
          },
        ],
      },
    },
    contact: {
      hero: {
        title: "Entre em contacto com os nossos especialistas",
        text: "Cada projeto come\u00e7a com uma conversa. Vamos discutir a sua vis\u00e3o e traduzi-la numa solu\u00e7\u00e3o pr\u00e1tica e de alto impacto.",
      },
      intro: {
        eyebrow: "Entre em contacto",
        title: "Vamos construir algo impactante",
        text: "Quer esteja a estruturar um investimento, a procurar consultoria governamental ou a explorar como a PRO-VEST pode ser o seu parceiro em Angola, queremos ouvi-lo.",
      },
      contactItems: [
        {
          title: "Telefone",
          primary: "+244 938 888 888",
          secondary: "+244 961 765 500",
        },
        {
          title: "Email",
          primary: "info@provest.co.ao",
          secondary: "Respondemos no prazo de 24 horas",
        },
        {
          title: "LinkedIn",
          primary: "PRO-VEST Capital Management",
          secondary: "Ligue-se \u00e0 nossa equipa",
        },
      ],
      locations: {
        eyebrow: "As nossas localiza\u00e7\u00f5es",
        title: "Onde operamos",
        text: "Com presen\u00e7a permanente em Angola e na \u00c1frica do Sul, n\u00e3o somos consultores remotos, mas parceiros inseridos nos mercados que servimos.",
        items: [
          {
            id: "ao",
            tab: "AO Luanda, Angola",
            title: "Luanda, Angola - Escrit\u00f3rio principal",
            address: "Rua Frederico Welwitschia, Torre Maculusso 5.\u00ba Andar - Luanda, Angola",
            mapTitle: "Mapa do escrit\u00f3rio de Luanda",
          },
          {
            id: "za",
            tab: "ZA Cidade do Cabo, AFS",
            title: "Cidade do Cabo, \u00c1frica do Sul - PROVEST Holding",
            address: "The Estuaries, Building 12, Century City Cape Town, 7441",
            mapTitle: "Mapa do escrit\u00f3rio da Cidade do Cabo",
          },
        ],
      },
    },
    privateSector: {
      hero: {
        title: "Solu\u00e7\u00f5es para o setor privado",
        text: "Solu\u00e7\u00f5es estrat\u00e9gicas e orientadas para a execu\u00e7\u00e3o que ajudam empresas a expandir, otimizar o desempenho e alcan\u00e7ar crescimento sustent\u00e1vel em mercados competitivos.",
        chipsLabel: "\u00c1reas de servi\u00e7o do setor privado",
        chips: ["Investimento e expans\u00e3o", "M&A e capital"],
      },
      expansion: {
        title: "Investimento e expans\u00e3o",
        text: "Projetos orientados para o crescimento e novos investimentos, desde oportunidades greenfield at\u00e9 \u00e0 transforma\u00e7\u00e3o empresarial completa.",
        cards: [
          {
            eyebrow: "Investimentos",
            title: "Projetos greenfield e novos investimentos",
            description: "Identificamos, estruturamos e executamos oportunidades de investimento greenfield, desde a viabilidade financeira at\u00e9 \u00e0 entrega do projeto. A nossa equipa junta capital, parceiros e capacidade de execu\u00e7\u00e3o para transformar oportunidades em ativos operacionais.",
            tags: ["Viabilidade", "Estrutura\u00e7\u00e3o", "Execu\u00e7\u00e3o"],
          },
          {
            eyebrow: "Estrutura",
            title: "Crescimento, expans\u00e3o e transforma\u00e7\u00e3o empresarial",
            description: "Apoiamos empresas estabelecidas a crescer, expandir para novos mercados ou transformar o seu modelo operacional atrav\u00e9s de consultoria estrat\u00e9gica, estrutura\u00e7\u00e3o de capital e apoio pr\u00e1tico de execu\u00e7\u00e3o que vai al\u00e9m da sala de reuni\u00f5es.",
            tags: ["Crescimento", "Expans\u00e3o", "Transforma\u00e7\u00e3o"],
          },
        ],
      },
      capital: {
        title: "M&A e capital",
        text: "Fus\u00f5es, aquisi\u00e7\u00f5es e reestrutura\u00e7\u00e3o de capital para navegar a complexidade e desbloquear valor estrat\u00e9gico.",
        cards: [
          {
            eyebrow: "M&A",
            title: "Fus\u00f5es e aquisi\u00e7\u00f5es (M&A)",
            description: "Assessoria integral em fus\u00f5es e aquisi\u00e7\u00f5es \u2014 desde a identifica\u00e7\u00e3o e avalia\u00e7\u00e3o de alvos at\u00e9 \u00e0 negocia\u00e7\u00e3o, dilig\u00eancia devida e conclus\u00e3o da transa\u00e7\u00e3o. Navegamos o contexto regulamentar e institucional \u00fanico de Angola para obter resultados que as consultoras que trabalham remotamente n\u00e3o conseguem alcan\u00e7ar.",
            tags: ["Valoriza\u00e7\u00e3o", "Negocia\u00e7\u00e3o", "Fecho"],
          },
          {
            eyebrow: "Capital e financeiro",
            title: "Reestrutura\u00e7\u00e3o de capital e otimiza\u00e7\u00e3o financeira",
            description: "Redesenhamos a estrutura de capital das empresas para desbloquear o crescimento, reduzir o risco financeiro e atrair novos investimentos \u2014 atrav\u00e9s da reestrutura\u00e7\u00e3o de capitais pr\u00f3prios, refinanciamento da d\u00edvida e modela\u00e7\u00e3o financeira alinhada com os objetivos estrat\u00e9gicos da empresa e as realidades do mercado de capitais de Angola.",
            tags: ["Reestrutura\u00e7\u00e3o", "Modela\u00e7\u00e3o financeira", "Otimiza\u00e7\u00e3o"],
          },
        ],
      },
      disciplines: {
        title: "Onde a estrat\u00e9gia encontra quatro disciplinas",
        text: "Do planeamento estrat\u00e9gico \u00e0 execu\u00e7\u00e3o, as nossas capacidades integradas asseguram clareza, efici\u00eancia e sucesso de longo prazo em cada projeto.",
        items: [
          {
            number: "01",
            title: "Estrat\u00e9gia",
            description: "Acompanha tend\u00eancias estrat\u00e9gicas do contexto econ\u00f3mico e institucional para clarificar prioridades e criar decis\u00f5es de investimento s\u00f3lidas.",
          },
          {
            number: "02",
            title: "Estrutura\u00e7\u00e3o financeira",
            description: "Desenhar a estrutura de capital certa alinhada com a escala do projeto, perfil de risco e requisitos dos investidores, desde a viabilidade at\u00e9 \u00e0 bancabilidade.",
          },
          {
            number: "03",
            title: "Parceiros certos",
            description: "Selecionar e integrar os parceiros t\u00e9cnicos, comerciais e institucionais certos usando uma metodologia de sele\u00e7\u00e3o baseada em melhores pr\u00e1ticas.",
          },
          {
            number: "04",
            title: "Disciplina de execu\u00e7\u00e3o",
            description: "Monitoriza\u00e7\u00e3o cont\u00ednua, coordena\u00e7\u00e3o institucional e alinhamento total entre estrat\u00e9gia, capital e execu\u00e7\u00e3o ao longo de toda a opera\u00e7\u00e3o.",
          },
        ],
      },
      contact: {
        title: "Transforme as suas ideias em resultados",
        text: "Do conceito \u00e0 execu\u00e7\u00e3o, ajudamos empresas a criar impacto significativo atrav\u00e9s de solu\u00e7\u00f5es personalizadas e de alto desempenho.",
      },
      cta: {
        title: "Pronto para fazer crescer o seu neg\u00f3cio no setor privado?",
        text: "Quer esteja a lan\u00e7ar um investimento greenfield, a seguir uma aquisi\u00e7\u00e3o ou a reestruturar para crescer, a nossa equipa est\u00e1 pronta para estruturar e executar.",
      },
    },
    publicSector: {
      hero: {
        title: "Solu\u00e7\u00f5es para o setor p\u00fablico",
        text: "Apoio de consultoria e representa\u00e7\u00e3o para governos e institui\u00e7\u00f5es desenvolverem projetos de impacto, refor\u00e7arem infraestruturas e impulsionarem progresso econ\u00f3mico de longo prazo.",
        chipsLabel: "\u00c1reas de servi\u00e7o do setor p\u00fablico",
        chips: ["Estrutura\u00e7\u00e3o de projetos", "PPP e modelos de concess\u00e3o"],
      },
      projects: {
        title: "Estrutura\u00e7\u00e3o de projetos",
        text: "Projetos de desenvolvimento econ\u00f3mico de grande escala que transformam prioridades p\u00fablicas complexas em programas banc\u00e1veis e execut\u00e1veis.",
        cards: [
          {
            eyebrow: "DESENVOLVIMENTO",
            title: "Projetos de desenvolvimento econ\u00f3mico de grande escala",
            description: "Estruturamos programas de investimento de grande escala em nome de governos e institui\u00e7\u00f5es, desde a viabilidade at\u00e9 \u00e0 estrutura\u00e7\u00e3o financeira e supervis\u00e3o da execu\u00e7\u00e3o. A nossa equipa navega o ambiente institucional angolano para desbloquear capital que de outra forma permaneceria inacess\u00edvel.",
            tags: ["Planeamento", "Estrutura\u00e7\u00e3o", "Execu\u00e7\u00e3o"],
          },
          {
            eyebrow: "INVESTIMENTO",
            title: "Programas de investimento com impacto territorial e setorial",
            description: "Desenhamos programas de investimento que geram impacto territorial e setorial, criando infraestruturas duradouras, diversifica\u00e7\u00e3o econ\u00f3mica e resultados de desenvolvimento alinhados com as prioridades nacionais de Angola e os planos provinciais de desenvolvimento.",
            tags: ["Territorial", "Setorial", "Impacto"],
          },
        ],
      },
      capital: {
        "title": "M&A e capital",
        "text": "Fus\u00f5es, aquisi\u00e7\u00f5es e reestrutura\u00e7\u00e3o de capital para navegar a complexidade e desbloquear valor estrat\u00e9gico.",
        "cards": [
          {
            "eyebrow": "PPP",
            "title": "Estrutura\u00e7\u00e3o de parcerias p\u00fablico-privadas (PPP)",
            "description": "Desenhamos e estruturamos enquadramentos PPP que alinham objetivos do setor p\u00fablico com incentivos do setor privado, criando estruturas que atraem investidores institucionais, institui\u00e7\u00f5es financeiras de desenvolvimento e capital internacional para os projetos priorit\u00e1rios de Angola.",
            "tags": [
              "Desenho PPP",
              "Aloca\u00e7\u00e3o de risco",
              "Estrutura\u00e7\u00e3o para investidores"
            ]
          },
          {
            "eyebrow": "Capital e financeiro",
            "title": "Reestrutura\u00e7\u00e3o de capital e otimiza\u00e7\u00e3o financeira",
            "description": "Redesenhamos a estrutura de capital das empresas para desbloquear o crescimento, reduzir o risco financeiro e atrair novos investimentos \u2014 atrav\u00e9s da reestrutura\u00e7\u00e3o de capitais pr\u00f3prios, refinanciamento da d\u00edvida e modela\u00e7\u00e3o financeira alinhada com os objetivos estrat\u00e9gicos da empresa e as realidades do mercado de capitais de Angola.",
            "tags": [
              "PPP",
              "Risco",
              "Bancabilidade"
            ]
          }
        ]
      },
      ppp: {
        title: "PPP e modelos de concess\u00e3o",
        text: "Estrutura\u00e7\u00e3o de Parcerias P\u00fablico-Privadas que tornam os projetos p\u00fablicos banc\u00e1veis, financi\u00e1veis e execut\u00e1veis.",
        cards: [
          {
            eyebrow: "PPP",
            title: "Estrutura\u00e7\u00e3o de parcerias p\u00fablico-privadas (PPP)",
            description: "Desenhamos e estruturamos enquadramentos PPP que alinham objetivos do setor p\u00fablico com incentivos do setor privado, criando estruturas que atraem investidores institucionais, institui\u00e7\u00f5es financeiras de desenvolvimento e capital internacional para os projetos priorit\u00e1rios de Angola.",
            tags: ["Desenho PPP", "Aloca\u00e7\u00e3o de risco", "Estrutura\u00e7\u00e3o para investidores"],
          },
          {
            eyebrow: "Modelos de concess\u00e3o",
            title: "Modelos de concess\u00e3o, partilha de risco e bancabilidade",
            description: "Desenhamos modelos de concess\u00e3o que distribuem o risco adequadamente entre partes p\u00fablicas e privadas, criando estruturas que cumprem os requisitos de bancabilidade dos financiadores, protegendo simultaneamente o interesse p\u00fablico e entregando resultados sustent\u00e1veis para as comunidades angolanas.",
            tags: ["PPP", "Risco", "Bancabilidade"],
          },
        ],
      },
      disciplines: {
        title: "Quatro pilares da entrega no setor p\u00fablico",
        text: "Do planeamento estrat\u00e9gico \u00e0 execu\u00e7\u00e3o, as nossas capacidades integradas asseguram clareza, efici\u00eancia e sucesso de longo prazo em cada projeto.",
      },
      contact: {
        title: "Transforme as suas ideias em resultados",
        text: "Do conceito \u00e0 execu\u00e7\u00e3o, ajudamos institui\u00e7\u00f5es p\u00fablicas a criar impacto significativo atrav\u00e9s de solu\u00e7\u00f5es personalizadas e de alto desempenho.",
      },
      cta: {
        title: "Pronto para estruturar o seu pr\u00f3ximo projeto do setor p\u00fablico?",
        text: "Quer seja um minist\u00e9rio, uma institui\u00e7\u00e3o provincial ou uma entidade multilateral \u00e0 procura de um parceiro de confian\u00e7a em Angola para estruturar e executar, estamos prontos.",
      },
    },
    privacy: {
      title: "Pol\u00edtica de Privacidade",
      text: "Esta pol\u00edtica explica como recolhemos, utilizamos, protegemos e gerimos informa\u00e7\u00f5es quando utiliza o nosso website ou interage com a nossa equipa.",
      lastUpdated: "\u00daltima atualiza\u00e7\u00e3o: 23 de abril de 2026",
      lead: "A PRO-VEST Capital Management respeita a privacidade e trata a informa\u00e7\u00e3o com cuidado. Esta p\u00e1gina apresenta uma vis\u00e3o simples das nossas pr\u00e1ticas gerais de privacidade.",
      sections: [
        {
          title: "Informa\u00e7\u00f5es que recolhemos",
          text: "Podemos recolher detalhes de contacto, informa\u00e7\u00f5es da empresa, pedidos relacionados com projetos, correspond\u00eancia e informa\u00e7\u00f5es t\u00e9cnicas como navegador, dispositivo e dados de utiliza\u00e7\u00e3o do website quando interage com a PRO-VEST Capital Management.",
        },
        {
          title: "Como utilizamos a informa\u00e7\u00e3o",
          text: "Utilizamos a informa\u00e7\u00e3o para responder a pedidos, avaliar potenciais colabora\u00e7\u00f5es, prestar servi\u00e7os de consultoria ou relacionados com projetos, melhorar o website, manter registos empresariais e proteger a seguran\u00e7a e integridade das nossas opera\u00e7\u00f5es.",
        },
        {
          title: "Partilha de informa\u00e7\u00e3o",
          text: "N\u00e3o vendemos informa\u00e7\u00f5es pessoais. Podemos partilhar informa\u00e7\u00f5es com consultores profissionais de confian\u00e7a, prestadores de servi\u00e7os, parceiros de projeto, reguladores ou autoridades quando necess\u00e1rio para fins leg\u00edtimos de neg\u00f3cio, legais, de conformidade ou operacionais.",
        },
        {
          title: "Prote\u00e7\u00e3o de dados",
          text: "Aplicamos salvaguardas administrativas, t\u00e9cnicas e organizacionais razo\u00e1veis, concebidas para proteger a informa\u00e7\u00e3o contra acesso n\u00e3o autorizado, perda, uso indevido ou altera\u00e7\u00e3o.",
        },
        {
          title: "As suas escolhas",
          text: "Pode contactar-nos para solicitar acesso, corre\u00e7\u00e3o ou elimina\u00e7\u00e3o de informa\u00e7\u00f5es pessoais, quando aplic\u00e1vel. Algumas informa\u00e7\u00f5es podem ser retidas por exig\u00eancias legais, contratuais, de auditoria ou por motivos leg\u00edtimos de neg\u00f3cio.",
        },
        {
          title: "Opera\u00e7\u00f5es internacionais",
          text: "Como o nosso trabalho pode envolver Angola, a \u00c1frica do Sul e parceiros internacionais, a informa\u00e7\u00e3o pode ser processada al\u00e9m-fronteiras quando necess\u00e1rio para opera\u00e7\u00f5es empresariais e execu\u00e7\u00e3o de projetos.",
        },
      ],
      updatesTitle: "Contacto e atualiza\u00e7\u00f5es",
      updatesText: "Se tiver d\u00favidas sobre esta Pol\u00edtica de Privacidade, contacte-nos atrav\u00e9s da p\u00e1gina de contacto. Podemos atualizar esta pol\u00edtica periodicamente para refletir altera\u00e7\u00f5es operacionais, legais ou do website.",
    },
    terms: {
      title: "Termos e Condi\u00e7\u00f5es",
      text: "Estes termos regem o seu acesso e utiliza\u00e7\u00e3o deste website e do seu conte\u00fado.",
      lastUpdated: "\u00daltima atualiza\u00e7\u00e3o: 23 de abril de 2026",
      lead: "Ao utilizar este website, aceita estes Termos e Condi\u00e7\u00f5es. Se n\u00e3o concordar com eles, por favor n\u00e3o utilize o website.",
      sections: [
        {
          title: "Utiliza\u00e7\u00e3o deste website",
          text: "Este website \u00e9 disponibilizado para informa\u00e7\u00e3o geral sobre a PRO-VEST Capital Management, as nossas capacidades e as nossas \u00e1reas de atua\u00e7\u00e3o. Concorda em utilizar o website de forma respons\u00e1vel e apenas para fins l\u00edcitos.",
        },
        {
          title: "Sem aconselhamento profissional",
          text: "O conte\u00fado do website n\u00e3o constitui aconselhamento financeiro, de investimento, jur\u00eddico, fiscal ou profissional. Qualquer rela\u00e7\u00e3o com a PRO-VEST Capital Management est\u00e1 sujeita a acordos escritos separados e a escopos de trabalho acordados.",
        },
        {
          title: "Propriedade intelectual",
          text: "Todos os textos, gr\u00e1ficos, marcas, layouts e outros materiais do website pertencem ou s\u00e3o licenciados \u00e0 PRO-VEST Capital Management, salvo indica\u00e7\u00e3o em contr\u00e1rio. N\u00e3o pode copiar, modificar ou reutilizar materiais sem autoriza\u00e7\u00e3o.",
        },
        {
          title: "Exatid\u00e3o da informa\u00e7\u00e3o",
          text: "Procuramos manter a informa\u00e7\u00e3o do website \u00fatil e exata, mas n\u00e3o garantimos que todo o conte\u00fado esteja completo, atual ou isento de erros. Podemos atualizar ou remover conte\u00fado a qualquer momento.",
        },
        {
          title: "Liga\u00e7\u00f5es de terceiros",
          text: "O website pode fazer refer\u00eancia a sites, ferramentas ou servi\u00e7os de terceiros. N\u00e3o somos respons\u00e1veis por conte\u00fados, disponibilidade, pol\u00edticas ou pr\u00e1ticas de terceiros.",
        },
        {
          title: "Limita\u00e7\u00e3o de responsabilidade",
          text: "Na m\u00e1xima extens\u00e3o permitida pela lei aplic\u00e1vel, a PRO-VEST Capital Management n\u00e3o ser\u00e1 respons\u00e1vel por perdas resultantes da utiliza\u00e7\u00e3o, impossibilidade de utiliza\u00e7\u00e3o ou confian\u00e7a depositada neste website ou no seu conte\u00fado.",
        },
      ],
      updatesTitle: "Altera\u00e7\u00f5es a estes termos",
      updatesText: "Podemos rever estes Termos e Condi\u00e7\u00f5es periodicamente. A continua\u00e7\u00e3o da utiliza\u00e7\u00e3o deste website ap\u00f3s atualiza\u00e7\u00f5es significa que aceita os termos revistos.",
    },
    banner: {
      title: "Website em constru\u00e7\u00e3o",
      text: "O nosso website est\u00e1 atualmente em constru\u00e7\u00e3o enquanto trabalhamos para melhorar a sua experi\u00eancia. Se tiver alguma quest\u00e3o, sinta-se \u00e0 vontade para nos contactar por email ou telefone. Obrigado pela sua paci\u00eancia.",
      callUs: "Ligue-nos",
      location: "Localiza\u00e7\u00e3o",
    },
  },
};

export default pt;
